import request from "../Utils/Request";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function postData(url: string, data?: any) {
  return request.post(url, data);
}
